import React from 'react';

class Banner extends React.Component {
    render() {
      
      return (
         <div style={{backgroundColor: 'whitesmoke'}}>
           <div class="card-group" style={{margin: '50px auto',width: '80%'}}>
                <div class="card" style={{border: '0'}}>
                    <div class="card-body text-center">
                        <a href="https://www.tosajuku.com/" target="_blank">
                        <h5 class="card-title font-weight-bold" style={{color: '#e2ad1d'}}>土佐塾</h5>
                        </a>
                    </div>
                </div>
                <div class="card" style={{border: '0'}}>
                    <div class="card-body text-center">
                        <h5 class="card-title font-weight-bold" style={{color: 'blue'}}>SKY</h5>
                    </div>
                </div>
                <div class="card" style={{border: '0'}}>
                    <div class="card-body text-center">
                        <h5 class="card-title font-weight-bold" style={{color: 'darkslateblue'}}>TS-APEX</h5>
                    </div>
                </div>
                <div class="card" style={{border: '0'}}>
                    <div class="card-body text-center">
                        <h5 class="card-title font-weight-bold" style={{color: '#e2ad1d'}}>STEMON</h5>
                    </div>
                </div>
           </div>
         </div>
      );
    }
  }
  
  export default Banner;
  